import { render, staticRenderFns } from "./passo10.vue?vue&type=template&id=b86a5bea&scoped=true&"
import script from "./passo10.vue?vue&type=script&lang=js&"
export * from "./passo10.vue?vue&type=script&lang=js&"
import style0 from "./passo10.vue?vue&type=style&index=0&id=b86a5bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86a5bea",
  null
  
)

export default component.exports